<script type="module">
import axios from 'axios'
import { format } from 'date-fns/format'
import { addDays } from 'date-fns/addDays'
import { startOfTomorrow } from 'date-fns/startOfTomorrow'
import ModalBus from '@/eventBus'

export default {
  name: 'QuoteFormVehicle',

  data() {
    return {
      vehicles: [],
      hours: [],
      form: {
        token: '',
        lastname: window.Laravel.user?.lastname,
        firstname: window.Laravel.user?.firstname,
        email: window.Laravel.user?.email,
        country: window.Laravel.user?.country,
        phone: window.Laravel.user?.phone,
        message: '',
        specific_fields: {
          booking: {
            travellers: null,
            start_date: format(startOfTomorrow(), 'yyyy-MM-dd'),
            start_hour: null,
            start_location: null,
            end_date: format(addDays(startOfTomorrow(), 1), 'yyyy-MM-dd'),
            end_hour: null,
            end_location: null,
            vehicles: [],
            drivers: [window.Laravel.quoteFormVehicle.driversYears[0]],
          },

          addSales: {
            gearbox: window.Laravel.quoteFormVehicle.settings.gearboxes[0],
            baby_seat: 0,
            booster: 0,
            kids_age: null,
            roofRack: window.Laravel.quoteFormVehicle.settings.roofRack[0],
          },
        },
      },

      sending: false,
      errorMessage: '',
      successMessage: '',
      errors: undefined,
      message: '',
    }
  },

  computed: {
    Laravel: () => window.Laravel,

    hasBoosterOrBabySeat() {
      return this.form.specific_fields.addSales.booster + this.form.specific_fields.addSales.baby_seat > 0
    },
  },

  mounted() {
    this.getVehicles()
    this.initHours()
  },

  methods: {
    initHours() {
      for (let hour = 0; hour < 24; hour++) {
        this.hours = [...this.hours, this.formatHour(hour, 0)]
      }
    },

    formatHour(hour, minute) {
      let hourFormatted = hour.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
      let minuteFormatted = minute.toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
      return `${hourFormatted}:${minuteFormatted}`
    },

    getVehicles() {
      axios
        .get('/api/vehicles')
        .then(
          (response) =>
            (this.vehicles = response.data.data.map((vehicle) => {
              vehicle.selected = false
              return vehicle
            })),
        )
        .catch(() => new Error('No vehicles classes'))
    },

    selectVehicle(vehicleId, vehicleName) {
      let item = this.form.specific_fields.booking.vehicles.find((vehicle) => vehicle.id === vehicleId)

      if (!item) {
        this.form.specific_fields.booking.vehicles.push({
          id: vehicleId,
          name: vehicleName,
        })
      } else {
        this.form.specific_fields.booking.vehicles = this.form.specific_fields.booking.vehicles.filter(
          (vehicle) => vehicle.id !== item.id,
        )
      }

      this.vehicles.forEach((vehicle) => {
        if (vehicle.id === vehicleId) {
          vehicle.selected = !vehicle.selected
        }
      })
    },

    addDriver() {
      this.form.specific_fields.booking.drivers.push(window.Laravel.quoteFormVehicle.driversYears[0])
    },

    deleteDriver(index) {
      this.form.specific_fields.booking.drivers.splice(index, 1)
    },

    closeForm() {
      ModalBus.emit('close')
    },

    handleSubmit() {
      this.sending = true
      this.errorMessage = ''
      this.errors = undefined
      this.successMessage = ''

      this.$recaptcha('vehicle').then((token) => {
        this.form.token = token
        axios
          .post('/submission/vehicle', this.form)
          .then((response) => {
            this.successMessage = response.data.message
            this.$root.openSuccessQuoteFormVehicle({
              url: window.Laravel.quoteFormVehicle.vehicleListUrl,
            })
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors || {}
            } else if (error.response.status === 500 || error.response.status === 401) {
              this.errorMessage = error.response.data.message
            }
          })
      })
    },
  },
}
</script>

<template>
  <div class="overflow-auto border border-lightgray bg-lightgray lg:rounded-2xl">
    <div class="item-center flex justify-between border-b-2 border-light/25 px-6 py-4">
      <div class="flex items-center">
        <h3 class="font-poppins text-xl font-medium text-secondary">
          {{ $t('vehicles.quoteForm.title') }}
        </h3>
      </div>
      <button
        class="relative h-10 w-10 rounded-full bg-secondary focus:outline-none lg:hidden"
        @click="closeForm">
        <div
          class="absolute left-1/2 top-1/2 flex h-1/2 w-1/2 -translate-x-1/2 -translate-y-1/2 flex-col items-end justify-between">
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full rotate-45 rounded bg-white"></div>
          <div class="header-closed absolute bottom-1/2 h-0.5 w-full -rotate-45 rounded bg-white"></div>
        </div>
      </button>
    </div>
    <form
      method="POST"
      @submit.prevent="handleSubmit">
      <div class="p-5">
        <div
          v-if="errorMessage"
          class="relative mb-3 mt-3 rounded-lg bg-red-100 px-3 py-3 text-sm text-red-700">
          {{ errorMessage }}
        </div>
        <div
          v-if="successMessage"
          class="relative mb-3 mt-3 rounded-lg bg-emerald-100 px-3 py-3 text-sm text-emerald-700">
          {{ successMessage }}
        </div>

        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary"></user>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.first.title') }}
          </h3>
        </div>
        <div class="w-full">
          <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.lastname.label') }}</span>
              <input
                v-model="form.lastname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.lastname.placeholder')"
                class="form__input bg-white"
                name="lastname"
                type="text" />
              <span
                v-if="errors && errors['lastname']"
                class="text-xs text-red-500"
                >{{ errors['lastname'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.firstname.label') }}</span>
              <input
                v-model="form.firstname"
                :placeholder="$t('commons.quoteForm.customerInfos.form.firstname.placeholder')"
                class="form__input bg-white"
                name="firstname"
                type="text" />
              <span
                v-if="errors && errors['firstname']"
                class="text-xs text-red-500"
                >{{ errors['firstname'][0] }}</span
              >
            </label>
          </div>
          <label class="form__label">
            <span>{{ $t('commons.quoteForm.customerInfos.form.email.label') }}</span>
            <input
              v-model="form.email"
              :placeholder="$t('commons.quoteForm.customerInfos.form.email.placeholder')"
              :disabled="$root.user.email"
              :class="$root.user.email ? 'bg-transparent' : 'bg-white'"
              class="form__input"
              name="email"
              type="email" />
            <span
              v-if="errors && errors['email']"
              class="text-xs text-red-500"
              >{{ errors['email'][0] }}</span
            >
          </label>
          <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.country.label') }}</span>
              <select
                v-model="form.country"
                class="form__input bg-white"
                name="country">
                <option
                  disabled
                  :value="null">
                  Sélectionner
                </option>
                <option
                  v-for="country in Laravel.quoteFormVehicle.countriesList"
                  :value="country.value">
                  {{ country.label }}
                </option>
              </select>
              <span
                v-if="errors && errors['country']"
                class="text-xs text-red-500"
                >{{ errors['country'][0] }}</span
              >
            </label>
            <label class="form__label">
              <span>{{ $t('commons.quoteForm.customerInfos.form.phone.label') }}</span>
              <div class="relative h-auto w-full">
                <input
                  v-model="form.phone"
                  :placeholder="$t('commons.quoteForm.customerInfos.form.phone.placeholder')"
                  class="form__input w-full bg-white"
                  name="phone"
                  required />
              </div>
              <span
                v-if="errors && errors['phone']"
                class="mt-2 text-xs text-red-500"
                >{{ errors['phone'][0] }}</span
              >
            </label>
          </div>
          <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
            <label class="form__label">
              <span>{{ $t('vehicles.quoteForm.sections.first.inputs.number.label') }}</span>
              <select
                v-model="form.specific_fields.booking.travellers"
                class="form__input bg-white"
                name="number">
                <option
                  disabled
                  :value="null">
                  Sélectionner
                </option>
                <option
                  v-for="traveller in 10"
                  :value="traveller">
                  {{ traveller }}
                </option>
              </select>
              <span
                v-if="errors && errors['specific_fields.booking.travellers']"
                class="text-xs text-red-500"
                >{{ errors['specific_fields.booking.travellers'][0] }}</span
              >
            </label>
          </div>
        </div>
      </div>

      <div class="w-full bg-lightgray px-6 py-4">
        <div class="flex w-full items-center">
          <svg
            class="h-4 w-4"
            fill="none"
            height="16"
            viewBox="0 0 15 16"
            width="15"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 0V16H2V12H15V0H0ZM4 10H2V8H4V10ZM4 4H2V2H4V4ZM7 7H5V5H7V7ZM10 10H8V8H10V10ZM10 4H8V2H10V4ZM13 7H11V5H13V7Z"
              fill="#469752" />
          </svg>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.second.title') }}
          </h3>
        </div>
        <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
          <label class="form__label">
            <span>{{ $t('vehicles.quoteForm.sections.second.inputs.dateStart.label') }}</span>
            <input
              id="start_date"
              v-model="form.specific_fields.booking.start_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.start_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_date'][0] }}</span
            >
          </label>
          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.second.inputs.hourStart.label') }}
            <select
              v-model="form.specific_fields.booking.start_hour"
              class="form__input bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="hour in hours"
                :value="hour">
                {{ hour }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.start_hour']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.start_hour'][0] }}</span
            >
          </label>
        </div>
        <label class="form__label">
          {{ $t('vehicles.quoteForm.sections.second.inputs.placeStart.label') }}
          <select
            v-model="form.specific_fields.booking.start_location"
            class="form__input bg-white"
            name="place-start">
            <option
              disabled
              :value="null">
              Sélectionner
            </option>
            <optgroup
              v-for="group in Laravel.quoteFormVehicle.locationsList"
              :key="group.name"
              :label="group.name"
              class="text-italic font-bold text-black">
              <option
                v-for="item in group.options"
                :value="item.name ? item.name : item.title">
                {{ item.name ? item.name : item.title }}
              </option>
            </optgroup>
          </select>
          <span
            v-if="errors && errors['specific_fields.booking.start_location']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.start_location'][0] }}</span
          >
        </label>
      </div>

      <div class="w-full bg-lightgray px-6 py-4">
        <div class="flex w-full items-center">
          <svg
            class="h-4 w-4"
            fill="none"
            height="16"
            viewBox="0 0 15 16"
            width="15"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 0V16H2V12H15V0H0ZM4 10H2V8H4V10ZM4 4H2V2H4V4ZM7 7H5V5H7V7ZM10 10H8V8H10V10ZM10 4H8V2H10V4ZM13 7H11V5H13V7Z"
              fill="#469752" />
          </svg>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.third.title') }}
          </h3>
        </div>
        <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
          <div class="form__label">
            <span>{{ $t('vehicles.quoteForm.sections.third.inputs.dateEnd.label') }}</span>
            <input
              id="end_date"
              v-model="form.specific_fields.booking.end_date"
              class="form__input"
              type="date" />
            <span
              v-if="errors && errors['specific_fields.booking.end_date']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.end_date'][0] }}</span
            >
          </div>
          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.third.inputs.hourEnd.label') }}
            <select
              v-model="form.specific_fields.booking.end_hour"
              class="form__input bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="hour in hours"
                :value="hour">
                {{ hour }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.end_hour']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.end_hour'][0] }}</span
            >
          </label>
        </div>
        <label class="form__label">
          {{ $t('vehicles.quoteForm.sections.third.inputs.placeEnd.label') }}
          <select
            v-model="form.specific_fields.booking.end_location"
            class="form__input bg-white">
            <option
              disabled
              :value="null">
              Sélectionner
            </option>
            <optgroup
              v-for="group in Laravel.quoteFormVehicle.locationsList"
              :key="group.name"
              :label="group.name"
              class="text-italic font-bold text-black">
              <option
                v-for="item in group.options"
                :value="item.name ? item.name : item.title">
                {{ item.name ? item.name : item.title }}
              </option>
            </optgroup>
          </select>
          <span
            v-if="errors && errors['specific_fields.booking.end_location']"
            class="text-xs text-red-500"
            >{{ errors['specific_fields.booking.end_location'][0] }}</span
          >
        </label>
      </div>

      <div class="w-full bg-lightgray px-6 py-4">
        <div class="mb-4 flex w-full items-center">
          <car class="h-4 w-4 text-primary" />
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.fourth.title') }}
          </h3>
        </div>

        <div class="row-gapx-6 grid grid-cols-2 gap-x-5 pb-4 md:grid-cols-2 xl:grid-cols-3">
          <button
            v-for="vehicle in vehicles"
            :key="vehicle.id"
            class="relative text-left focus:outline-none"
            type="button"
            @click="selectVehicle(vehicle.id, vehicle.title)">
            <div class="pt-full relative w-full overflow-hidden rounded-xl bg-white">
              <img
                :src="vehicle.thumbnail"
                class="aspect-square w-full bg-black/10 object-cover" />
              <div
                v-if="vehicle.selected"
                class="absolute left-0 top-0 flex h-full w-full items-center justify-center">
                <svg
                  class="h-auto w-1/2"
                  fill="none"
                  height="36"
                  viewBox="0 0 36 36"
                  width="36"
                  xmlns="http://www.w3.org/2000/svg">
                  <rect
                    fill="#469752"
                    height="36"
                    rx="18"
                    width="36" />
                  <path
                    d="M14.6252 22.4826L10.0214 17.8789L9.9002 17.7576L9.77898 17.8789L8.20398 19.4539L8.08276 19.5751L8.20398 19.6963L14.504 25.9963L14.6252 26.1175L14.7464 25.9963L28.2464 12.4963L28.3676 12.3751L28.2464 12.2539L26.6714 10.6789L26.5502 10.5576L26.429 10.6789L14.6252 22.4826Z"
                    fill="white"
                    stroke="white"
                    stroke-width="0.342857" />
                </svg>
              </div>
            </div>
            <span class="my-2 block font-poppins font-normal">{{ vehicle.title }}</span>
            <div class="attributes-list mb-6 flex w-full justify-between">
              <div
                class="flex items-center whitespace-nowrap rounded-full border px-2 py-1 font-sans text-xs text-light">
                <svg
                  class="mr-2 h-3 w-3"
                  fill="none"
                  height="9"
                  viewBox="0 0 10 9"
                  width="10"
                  xmlns="http://www.w3.org/2000/svg">
                  <g clip-path="url(#clip0)">
                    <path
                      d="M7.90874 4.64178C7.64448 5.13655 7.25087 5.55657 6.76666 5.86048C6.28246 6.1644 5.72435 6.34174 5.14728 6.37503C4.57021 6.34174 4.01211 6.1644 3.5279 5.86048C3.0437 5.55657 2.65009 5.13655 2.38583 4.64178C1.46743 5.28446 0.824662 6.22783 0.578372 7.29453C0.562029 7.36731 0.568571 7.44313 0.597165 7.51231C0.625759 7.5815 0.67511 7.64093 0.738931 7.68303C2.03621 8.54083 3.57325 9.00001 5.14728 9.00001C6.72131 9.00001 8.25836 8.54083 9.55564 7.68303C9.61946 7.64093 9.66881 7.5815 9.6974 7.51231C9.726 7.44313 9.73254 7.36731 9.71619 7.29453C9.4699 6.22783 8.82713 5.28446 7.90874 4.64178Z"
                      fill="#F05A28" />
                    <path
                      d="M5.14732 0C4.52718 0 3.93244 0.237053 3.49394 0.65901C3.05543 1.08097 2.80908 1.65326 2.80908 2.25C2.80908 3.45825 3.79114 5.25 5.14732 5.25C6.50349 5.25 7.48555 3.45825 7.48555 2.25C7.48555 1.65326 7.2392 1.08097 6.8007 0.65901C6.36219 0.237053 5.76746 0 5.14732 0V0Z"
                      fill="#F05A28" />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect
                        fill="white"
                        height="9"
                        transform="translate(0.470703)"
                        width="9.35294" />
                    </clipPath>
                  </defs>
                </svg>
                <span>{{ `${vehicle.seats}` }}</span>
              </div>
              <div class="flex items-center whitespace-nowrap rounded-full border px-2 py-1 font-sans text-xs">
                <svg
                  class="mr-2 h-3 w-3"
                  fill="none"
                  height="9"
                  viewBox="0 0 9 9"
                  width="9"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.25 9H6.75V0.5625C6.75 0.225 6.525 0 6.1875 0H2.8125C2.475 0 2.25 0.225 2.25 0.5625V9ZM3.375 1.125H5.625V2.25H3.375V1.125Z"
                    fill="#727272" />
                  <path
                    d="M8.4375 2.25H7.875V9H8.4375C8.775 9 9 8.775 9 8.4375V2.8125C9 2.475 8.775 2.25 8.4375 2.25Z"
                    fill="#727272" />
                  <path
                    d="M1.125 2.25H0.5625C0.225 2.25 0 2.475 0 2.8125V8.4375C0 8.775 0.225 9 0.5625 9H1.125V2.25Z"
                    fill="#727272" />
                </svg>
                <span>{{ `${vehicle.luggages}` }}</span>
              </div>
            </div>
          </button>
        </div>
        <span
          v-if="errors && errors['specific_fields.booking.vehicles']"
          class="text-xs text-red-500"
          >{{ errors['specific_fields.booking.vehicles'][0] }}</span
        >
      </div>

      <div class="w-full bg-lightgray px-6 py-4">
        <div class="flex w-full items-center">
          <svg
            class="h-4 w-4"
            fill="none"
            height="16"
            viewBox="0 0 15 16"
            width="15"
            xmlns="http://www.w3.org/2000/svg">
            <path
              d="M0 0V16H2V12H15V0H0ZM4 10H2V8H4V10ZM4 4H2V2H4V4ZM7 7H5V5H7V7ZM10 10H8V8H10V10ZM10 4H8V2H10V4ZM13 7H11V5H13V7Z"
              fill="#469752" />
          </svg>
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.fifth.title') }}
          </h3>
        </div>
        <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
          <label
            v-for="(driver, index) in form.specific_fields.booking.drivers"
            :key="index"
            class="form__label">
            <div class="flex items-center justify-between">
              {{ $t('vehicles.quoteForm.sections.fifth.inputs.age.label') }}
              <button
                v-if="form.specific_fields.booking.drivers.length > 1"
                class="mr-2 text-xl text-red-500 focus:outline-none"
                type="button"
                @click="deleteDriver(index)">
                &times;
              </button>
            </div>
            <select
              v-model="form.specific_fields.booking.drivers[index]"
              class="form__input bg-white">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="year in Laravel.quoteFormVehicle.driversYears"
                :value="year">
                {{ year }}
              </option>
            </select>
            <span
              v-if="errors && errors['specific_fields.booking.drivers.' + index]"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.booking.drivers.' + index][0] }}</span
            >
          </label>
          <div
            v-if="form.specific_fields.booking.drivers.length < 4"
            class="flex items-end justify-between py-3">
            <button
              class="font-popins flex w-full items-center text-xs font-medium text-secondary focus:outline-none"
              type="button"
              @click="addDriver">
              <svg
                class="mr-3 h-7.5 w-7.5 rounded-full border border-secondary p-2 font-medium lg:mr-1"
                fill="none"
                height="13"
                viewBox="0 0 13 13"
                width="13"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9167 5.95832H7.04175V1.08332C7.04175 0.758323 6.82508 0.541656 6.50008 0.541656C6.17508 0.541656 5.95841 0.758323 5.95841 1.08332V5.95832H1.08341C0.758415 5.95832 0.541748 6.17499 0.541748 6.49999C0.541748 6.82499 0.758415 7.04166 1.08341 7.04166H5.95841V11.9167C5.95841 12.2417 6.17508 12.4583 6.50008 12.4583C6.82508 12.4583 7.04175 12.2417 7.04175 11.9167V7.04166H11.9167C12.2417 7.04166 12.4584 6.82499 12.4584 6.49999C12.4584 6.17499 12.2417 5.95832 11.9167 5.95832Z"
                  fill="#F05A28" />
              </svg>
              {{ $t('buttons.addDriver') }}
            </button>
          </div>
        </div>
      </div>

      <div class="w-full px-6 py-4">
        <div class="flex w-full items-center">
          <user class="h-4 w-4 text-primary" />
          <h3 class="ml-4 font-poppins text-xl font-medium">
            {{ $t('vehicles.quoteForm.sections.sixth.title') }}
          </h3>
        </div>
        <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.sixth.inputs.baby.label') }}
            <select
              v-model="form.specific_fields.addSales.baby_seat"
              class="form__input bg-white"
              name="baby">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="baby_seat in Laravel.quoteFormVehicle.settings.baby_seats.max + 1"
                :value="baby_seat - 1">
                {{ baby_seat - 1 }}
              </option>
            </select>
            <span class="mt-2 font-sans text-xs font-normal text-light">
              {{ $t('vehicles.quoteForm.sections.sixth.inputs.baby.info') }}
            </span>
            <span
              v-if="errors && errors['specific_fields.addSales.baby_seat']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.addSales.baby_seat'][0] }}</span
            >
          </label>

          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.sixth.inputs.booster.label') }}
            <select
              v-model="form.specific_fields.addSales.booster"
              class="form__input bg-white"
              name="booster">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="booster in Laravel.quoteFormVehicle.settings.boosters.max + 1"
                :value="booster - 1">
                {{ booster - 1 }}
              </option>
            </select>
            <span class="mt-2 font-sans text-xs font-normal text-light">
              {{ $t('vehicles.quoteForm.sections.sixth.inputs.booster.info') }}
            </span>
            <span
              v-if="errors && errors['specific_fields.addSales.booster']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.addSales.booster'][0] }}</span
            >
          </label>

          <label
            v-if="hasBoosterOrBabySeat"
            class="form__label">
            <span>{{ $t('vehicles.quoteForm.sections.sixth.inputs.kidsAge.label') }}</span>
            <input
              v-model="form.specific_fields.addSales.kids_age"
              :placeholder="$t('vehicles.quoteForm.sections.sixth.inputs.kidsAge.placeholder')"
              class="form__input"
              type="text" />
            <span class="mt-2 font-sans text-xs font-normal text-light">
              {{ $t('vehicles.quoteForm.sections.sixth.inputs.kidsAge.info') }}
            </span>
            <span
              v-if="errors && errors['specific_fields.addSales.kidsAge']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.addSales.kidsAge'][0] }}</span
            >
          </label>
        </div>
        <div class="grid grid-cols-2 gap-x-4 lg:grid-cols-1 xl:grid-cols-2">
          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.sixth.inputs.roofRack.label') }}
            <select
              v-model="form.specific_fields.addSales.roofRack"
              class="form__input bg-white"
              name="roof-rack">
              <option
                disabled
                :value="null">
                Sélectionner
              </option>
              <option
                v-for="option in Laravel.quoteFormVehicle.settings.roofRack"
                :value="option">
                {{ option }}
              </option>
            </select>
            <span class="mt-2 font-sans text-xs font-normal text-light">
              {{ $t('vehicles.quoteForm.sections.sixth.inputs.roofRack.info') }}
            </span>
            <span
              v-if="errors && errors['specific_fields.addSales.roofRack']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.addSales.roofRack'][0] }}</span
            >
          </label>

          <label class="form__label">
            {{ $t('vehicles.quoteForm.sections.sixth.inputs.gearbox.label') }}
            <select
              v-model="form.specific_fields.addSales.gearbox"
              class="form__input bg-white"
              name="gearbox">
              <option
                v-for="gearbox in Laravel.quoteFormVehicle.settings.gearboxes"
                :value="gearbox">
                {{ gearbox }}
              </option>
            </select>
            <span class="mt-2 font-sans text-xs font-normal text-light">
              {{ $t('vehicles.quoteForm.sections.sixth.inputs.gearbox.info') }}
            </span>
            <span
              v-if="errors && errors['specific_fields.addSales.gearbox']"
              class="text-xs text-red-500"
              >{{ errors['specific_fields.addSales.gearbox'][0] }}</span
            >
          </label>
        </div>
        <div class="mb-4 mt-4 flex flex-col">
          <label class="form__label">
            {{ $t('vehicles.quoteForm.more') }}
          </label>
          <textarea
            v-model="form.message"
            :placeholder="$t('vehicles.quoteForm.textarea')"
            class="mt-2 rounded-lg border border-light/25 bg-white p-4 text-sm"
            name="comment">
          </textarea>
          <span class="mt-4 font-sans text-xs text-light">{{ $t('commons.quoteForm.mentions') }}</span>
        </div>
      </div>
      <div class="px-5 pb-5">
        <button
          class="btn"
          type="submit">
          {{ $t('buttons.send') }}
        </button>
      </div>
    </form>
  </div>
</template>
